import {
  FiHeart,
  FiUsers,
  FiTarget,
  FiEye,
  FiShield,
  FiBookOpen,
  FiActivity,
  FiSun,
  FiDroplet,
  FiHome,
  FiAward,
  FiMapPin,
  FiCalendar,
  FiCheck,
  FiMail,
  FiPhone,
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiYoutube,
  FiClock,
  FiExternalLink,
  FiUser,
  FiArrowRight,
  FiChevronDown,
  FiMenu,
  FiX,
  FiStar
} from "react-icons/fi";

const iconMap = {
  FiHeart,
  FiUsers,
  FiTarget,
  FiEye,
  FiShield,
  FiBookOpen,
  FiActivity,
  FiSun,
  FiDroplet,
  FiHome,
  FiAward,
  FiMapPin,
  FiCalendar,
  FiCheck,
  FiMail,
  FiPhone,
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiYoutube,
  FiClock,
  FiExternalLink,
  FiUser,
  FiArrowRight,
  FiChevronDown,
  FiMenu,
  FiX,
  FiStar
};

export const getIcon = (iconName) => {
  return iconMap[iconName] || FiHeart;
};

export default getIcon;
